import React from "react";

import "./index.scss";

const CloneIcon = () => (
  <svg id="a" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" className="cloneParent">
    <path id="b" className="g" d="M0,0H32V32H0V0Z" />
    <g id="c">
      <path id="d" className="j" d="M9.15,19.46V8h9.96v.89H10.03v10.58h-.89Z" />
      <rect id="e" className="h" x="12.14" y="11.03" width="10.71" height="12.98" />
      <path id="f" className="i" d="M14.17,20.04c1.59,.03,3.15-.44,4.45-1.35,1.17-.92,1.95-2.23,2.21-3.7" />
    </g>
  </svg>
);

export default CloneIcon;
